import { wait } from "./wait";

export function WindowActivePoll(googleWindow) {
  // here we wait for callback from google auth in second window so we can close it
  try {
    if (googleWindow.document.URL.indexOf("googleauthcallback") > -1) {
      googleWindow.close();
      this.clearInterval();
    }
  } catch (e) {}
}
